import { ingestAPIObject } from "../utils/api";
import { getWeekOfYearFromTypeString, } from "../utils/week-of-year";
export class CustomerDTO {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
    }
    get mapCenter() {
        if (!this.globalMapCenterLatitude || !this.globalMapCenterLongitude) {
            return undefined;
        }
        return [this.globalMapCenterLongitude, this.globalMapCenterLatitude];
    }
    getWeekOfYear(date) {
        return getWeekOfYearFromTypeString(date, this.yearWeekType, this.startDayOfWeek);
    }
}
